import { styled, Grid } from "@mui/material";

export const DateContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "customColor",
})<{ customColor?: React.CSSProperties["color"] }>(({ customColor, theme }) => ({
  color: customColor ?? theme.palette.secondary.light,
  display: "flex",
  "& >.MuiTypography-root": {
    fontSize: "30px",
  },
  "& .MuiGrid-root": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& .MuiTypography-root": {
      lineHeight: "13px",
    },
  },
}));
